export interface IConfig {
  API_URL: string;
  GOOGLE_AD_SENSE_CLIENT: string;
  CLIENT_URL: string;
}

export const isDevelopment = () => true;

declare global {
  // tslint:disable-next-line:interface-name
  interface Window {
    appConfig: any;
  }
}

/** `.env` may hold `test.blackfridaynederland.nl` or `http://localhost:3001`; only a bare host gets https. */
const withScheme = (url: string): string => (url.startsWith("http") ? url : `https://${url}`);

const basePath =
  process.env.NODE_ENV !== "production"
    ? process.env.API_URL
      ? `${withScheme(process.env.API_URL).replace(/\/+$/, "")}/api/`
      : "https://test.blackfridaynederland.nl/api/"
    : `https://${process.env.API_URL}`;

export const GET_CONFIG: IConfig = {
  API_URL: basePath.replace(/\/+$/, ""),
  GOOGLE_AD_SENSE_CLIENT: "ca-pub-2496803522330859",
  CLIENT_URL: process.env.HOST?.includes("localhost")
    ? `${process.env.HOST}:${process.env.PORT}`
    : basePath.replace("/api", "")
};
